import { environmentCircuits } from 'src/environments/circuits/environment';

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const brandName = 'Wisen';

export const getLogo = {
  logoShort: isSafari ? './assets/media/logos/icon-wisen-160x160.png' : './assets/media/logos/icon-wisen-160x160.svg',
  logoShortForQRCode: isSafari ? './assets/media/logos/icon-wisen-qrcode-160x160.png' : './assets/media/logos/icon-wisen-qrcode-160x160.svg',
  logoForBackgroundBlue: isSafari ? './assets/media/logos/logo-wisen-white-700x250.png' : './assets/media/logos/logo-wisen-white-700x250.svg',
  logoForBackgroundWhite: isSafari ? './assets/media/logos/logo-wisen-blue-300x100.png' : './assets/media/logos/logo-wisen-blue-300x100.svg'
};

export const getImages = {
  userBlank: './assets/media/avatars/blank-300x300.svg',
  placeholderImage: './assets/media/placeholders/placeholder-image-400x400.svg',
  assetImage: environmentCircuits.cloudFront,
  error404: './assets/media/auth/404-error.png',
  error500: './assets/media/auth/500-error.png',
  fileImage: './assets/media/placeholders/fileImage.png'
}

export const getImageSensors = {
  NO_SENSOR: './assets/sensors/no-sensor.svg',
  K23_550x550: './assets/sensors/K23-550x550.svg',
  K23_100x100: './assets/sensors/K23-100x100.svg',
  LHT65N_550x550: './assets/sensors/LHT65N-550x550.svg',
  LHT65N_100x100: './assets/sensors/LHT65N-100x100.svg',
  LHT52_550x550: './assets/sensors/LHT52-550x550.svg',
  LHT52_100x100: './assets/sensors/LHT52-100x100.svg',
  SL04_550x550: './assets/sensors/SL-04-550x550.svg',
  SL04_100x100: './assets/sensors/SL-04-100x100.svg',
  K4PT_BEACON_550x550: './assets/sensors/K4PT_BEACON_550x550.svg',
  K4PT_BEACON_100x100: './assets/sensors/K4PT_BEACON_100x100.svg',
  S5_BEACON_550x550: './assets/sensors/S5_BEACON_550x550.svg',
  S5_BEACON_100x100: './assets/sensors/S5_BEACON_100x100.svg',
  L5G_550x550: './assets/sensors/L5G_550x550.svg',
  L5G_100x100: './assets/sensors/L5G_100x100.svg',
  L3G_550x550: './assets/sensors/L3G_550x550.svg',
  L3G_100x100: './assets/sensors/L3G_100x100.svg',
  LPS8N_550x550: './assets/sensors/LPS8N_550x550.svg',
  LPS8N_100x100: './assets/sensors/LPS8N_100x100.svg',
  LPS8NLTE_550x550: './assets/sensors/LPS8NLTE_550x550.svg',
  LPS8NLTE_100x100: './assets/sensors/LPS8NLTE_100x100.svg',
  LPS8v2LTE_550x550: './assets/sensors/LPS8v2LTE_550x550.svg',
  LPS8v2LTE_100x100: './assets/sensors/LPS8v2LTE_100x100.svg',
  RAK7266_550x550: './assets/sensors/RAK7266_550x550.svg',
  RAK7266_100x100: './assets/sensors/RAK7266_100x100.svg',
  RAK7268XXX_550x550: './assets/sensors/RAK7268XXX_550x550.svg',
  RAK7268XXX_100x100: './assets/sensors/RAK7268XXX_100x100.svg',
  IoTiC_550x550: './assets/sensors/IoTiC_550x550.svg',
  IoTiC_100x100: './assets/sensors/IoTiC_100x100.svg',
  L3G_Solar_550x550: './assets/sensors/L3G_Solar_550x550.svg',
  L3G_Solar_100x100: './assets/sensors/L3G_Solar_100x100.svg'
}

export const getImageTechGateway = {
  ble: './assets/media/icons/devices/bluetooth-160x160.svg',
  lorawan: './assets/media/icons/devices/lorawan-160x160.svg',
  gateway: './assets/gateways/gateway-320x320.svg'
}
